import hTable from "@/components/Generators/hTable.vue";
import hSearchForm from "@/components/Generators/hSearchForm";
// import hImage from "@/components/Generators/hImage";
// import hDrawer from "@/components/Generators/hDrawer";
// import hForm from "@/components/Generators/hForm";

export default [
  { comName: "hTable", com: hTable },
  { comName: "hSearchForm", com: hSearchForm },
  // { comName: "hImage", com: hImage },
  // { comName: "hDrawer", com: hDrawer },
  // { comName: "hForm", com: hForm },
];
